import React from 'react';

function formatGroupLabel(key) {
  if (key.includes('-')) {
    const [plan, ...tierParts] = key.split('-');
    const tier = tierParts.join('-');
    return `${plan.charAt(0).toUpperCase() + plan.slice(1)} - ${tier.charAt(0).toUpperCase() + tier.slice(1)}`;
  }
  return key.charAt(0).toUpperCase() + key.slice(1);
}

export function StripeSummaryStats({ stats, chartView, getPlanColor }) {
  const { totalRevenue, totalCount, pending, failed, byPlan, totalDiscount, amountMode } = stats || {};

  const revenueLabel = amountMode === 'full' ? 'Total (Pre-Discount)' : 'Total Revenue';

  return (
    <div className="stripe-summary-stats">
      <div className="stripe-summary-row">
        <div className="stripe-summary-card">
          <div className="stripe-summary-label">{revenueLabel}</div>
          <div className="stripe-summary-value stripe-summary-revenue">
            ${typeof totalRevenue === 'number' ? totalRevenue.toFixed(2) : '0.00'}
          </div>
        </div>
        <div className="stripe-summary-card">
          <div className="stripe-summary-label">Successful Transactions</div>
          <div className="stripe-summary-value">{totalCount ?? 0}</div>
        </div>
        <div className="stripe-summary-card">
          <div className="stripe-summary-label">Pending</div>
          <div className="stripe-summary-value stripe-summary-pending">{pending ?? 0}</div>
        </div>
        <div className="stripe-summary-card">
          <div className="stripe-summary-label">Failed</div>
          <div className="stripe-summary-value stripe-summary-failed">{failed ?? 0}</div>
        </div>
        {typeof totalDiscount === 'number' && totalDiscount > 0 && (
          <div className="stripe-summary-card">
            <div className="stripe-summary-label">Total Discounts</div>
            <div className="stripe-summary-value stripe-summary-discount">
              ${totalDiscount.toFixed(2)}
            </div>
          </div>
        )}
      </div>
      {byPlan && Object.keys(byPlan).length > 0 && (
        <div className="stripe-summary-by-plan">
          <div className="stripe-summary-label">
            {chartView === 'byTier' ? 'Revenue by Plan & Tier' : 'Revenue by Plan'}
          </div>
          <div className="stripe-summary-plan-grid">
            {Object.entries(byPlan).map(([planId, amount]) => (
              <div key={planId} className="stripe-summary-plan-item">
                <span
                  className="stripe-summary-plan-dot"
                  style={{ backgroundColor: getPlanColor(planId) }}
                />
                <span className="stripe-summary-plan-name">
                  {formatGroupLabel(planId)}
                </span>
                <span className="stripe-summary-plan-amount">${amount.toFixed(2)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
